import request from '@/utils/request'

// 查询教师表列表
export function listTeachers(query) {
  return request({
    url: '/OmdTeachers/teachers/list',
    method: 'get',
    params: query
  })
}

// 查询教师表详细
export function getTeachers(id) {
  return request({
    url: '/OmdTeachers/teachers/' + id,
    method: 'get'
  })
}

// 新增教师表
export function addTeachers(data) {
  return request({
    url: '/OmdTeachers/teachers',
    method: 'post',
    data: data
  })
}

// 修改教师表
export function updateTeachers(data) {
  return request({
    url: '/OmdTeachers/teachers',
    method: 'put',
    data: data
  })
}

// 删除教师表
export function delTeachers(id) {
  return request({
    url: '/OmdTeachers/teachers/' + id,
    method: 'delete'
  })
}
